import { CommonHttpOption } from "./../../services/http/base/common-http-option";
import { CoreService } from "./../../services/http/base/core";
import { Injectable } from "@angular/core";
import { ServiceRoute } from "src/app/services/http/base/service-route";
import { Observable } from "rxjs";

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

const MENUITEMS = [
  {
    state: "/",
    name: "HOME",
    type: "link",
    icon: "explore"
  },
  {
    state: "basic",
    name: "اطلاعات پایه",
    type: "sub",
    icon: "apps",
    badge: [{ type: "red", value: "5" }],
    children: [
      { state: "company", name: "شرکت ها" },
      { state: "majorList", name: "لیست مقطع ها" },
      { state: "groups", name: "گروه ها" },
      { state: "roles", name: "نقش ها" }
    ]
  },
  {
    state: "hrm",
    name: "مدیریت اطلاعات منابع انسانی مالی",
    type: "sub",
    icon: "photo",
    children: [{ state: "personalContract", name: "مدیریت قرارداد ها" }]
  },
  {
    state: "institute",
    name: "مدیریت اطلاعات پایه آموزشی",
    type: "sub",
    icon: "photo",
    children: [
      { state: "coursePattern", name: "الگوهای درس ها" },
      { state: "courseType", name: "نوع دوره" },
      { state: "termInfo", name: "مدیریت ترم ها" },
      { state: "course", name: "لیست واحدهای درسی" },
      { state: "educationPackage", name: "دوره های آموزشی" },
      { state: "placementTimeSheet", name: "برنامه ریزی زمانی" }
    ]
  },
  {
    state: "registration",
    name: "ثبت نام",
    type: "link",
    icon: "face"
  },
  {
    state: "placementReservation",
    name: "رزرو تعیین سطح",
    type: "link",
    icon: "looks_3"
  }
];

@Injectable()
export class MenuService {
  constructor(private core: CoreService) {}

  getAll(): Menu[] {
    return MENUITEMS;
  }

  add() {
    // MENUITEMS.push(menu);
  }

  getItemsForManager(): Observable<any> {
    return this.core.get(
      ServiceRoute.route.ListForManager,
      new CommonHttpOption().headers
    );
  }
}
